import React, { useEffect, useRef, useState } from "react";
import Reveal from "./Reveal";
import { STEPS } from "../../data/mock";

export default function HowItWorks() {
  const [progress, setProgress] = useState(0);
  const ref = useRef(null);
  useEffect(() => {
    const on = () => {
      const el = ref.current;
      if (!el) return;
      const rect = el.getBoundingClientRect();
      const total = rect.height + window.innerHeight;
      const p = Math.min(1, Math.max(0, (window.innerHeight - rect.top) / total));
      setProgress(p);
    };
    window.addEventListener("scroll", on); on();
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <section id="process" ref={ref} className="relative py-28 md:py-40 border-b hairline">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[var(--text-muted)] mb-8">
          <span className="h-px w-8 bg-[var(--line-2)]"></span>
          <span className="font-mono text-[10px] uppercase tracking-[0.3em]">How It Works</span>
        </div>
        <Reveal>
          <h2 className="font-display text-[54px] md:text-[100px] leading-[0.96] tracking-[-0.03em]">
            Four steps. One <span className="italic-serif text-[var(--ember-3)]">decision</span>.
          </h2>
        </Reveal>
        <Reveal delay={120}>
          <p className="mt-8 max-w-[720px] text-[var(--text-muted)] text-[17px] leading-[1.75]">
            No high-pressure calls. No funnel chasing. The path from application to brotherhood is straightforward, because we screen for men who are serious about being sharpened.
          </p>
        </Reveal>

        <div className="mt-24 relative">
          {/* Vertical spine */}
          <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-[var(--line-2)]">
            <div className="absolute top-0 left-0 w-full bg-gradient-to-b from-[var(--ember-2)] to-transparent" style={{ height: `${Math.min(progress * 140, 100)}%` }}></div>
          </div>

          <div className="space-y-16 md:space-y-24">
            {STEPS.map((s, i) => (
              <div key={s.n} className={`relative grid md:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
                <Reveal className="md:[direction:ltr] pl-16 md:pl-0 md:pr-16">
                  <div className="font-mono text-[11px] tracking-[0.24em] text-[var(--ember-3)]">Step {s.n}</div>
                  <h3 className="font-display text-[42px] md:text-[68px] leading-[1] tracking-[-0.02em] mt-3">{s.title}</h3>
                  <p className="text-[var(--text-muted)] text-[16px] leading-[1.75] mt-5 max-w-[440px]">{s.body}</p>
                </Reveal>
                <div className="hidden md:block"></div>
                {/* Node */}
                <div className="absolute left-6 md:left-1/2 top-6 -translate-x-1/2 flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-[var(--bg)] border border-[var(--ember-2)] relative">
                    <span className="absolute inset-[-6px] rounded-full border border-[var(--ember-2)] opacity-30 ember-dot"></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
